export default __webpack_public_path__ + "static/media/gift_10_expired.144c502d.webp";